import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/**
 * -chat- Liaison en-tête <-> messagerie <-> page notifications.
 *  - countersChanged : quelque chose a été lu -> l'en-tête rafraîchit ses compteurs tout de suite
 *    (au lieu d'attendre son rafraîchissement de 20 s).
 *  - chatHome : clic sur l'icône messagerie alors qu'on est déjà dans la messagerie -> retour à la liste.
 */
@Injectable({ providedIn: 'root' })
export class ChatBusService {
  readonly countersChanged = new Subject<void>();
  readonly chatHome = new Subject<void>();
}

/** -chat fixes- notification creee par la messagerie (lien vers une conversation) */
export function isChatNotif(item: { lien?: string }): boolean {
  return !!item?.lien?.startsWith('/apps/chat');
}

/**
 * -chat fixes- Titre AFFICHE d'une notification : "Nouveau message de X" (enregistre en francais par le serveur)
 * est traduit a l'affichage ; le texte enregistre ne change pas. Les autres titres (apps) restent tels quels.
 */
export function notifTitle(item: { titre?: string; lien?: string }, t: TranslateService): string {
  const prefix = 'Nouveau message de ';
  if (isChatNotif(item) && item.titre?.startsWith(prefix)) {
    return t.instant('notif.newMessageFrom', { name: item.titre.slice(prefix.length) });
  }
  return item?.titre || '';
}
